export default __webpack_public_path__ + "static/media/el22.b6863301.svg";